import React, { useRef } from 'react';
import './Contact.css'
import emailjs from 'emailjs-com';

const Contact = () => {

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_uymfv09', 'template_wn78qd7', e.target, 'user_XT9aFN4I8qhUs54L8YjQH')
      .then((result) => {
        alert("Success");
        document.getElementById("contact-form").reset();


      }, (error) => {
        console.log(error.text);

      });
  };

  return (

    <div id='contact' className='pt-5 pb-5' style={{ backgroundColor: '#1f2833', height: '100%', paddingLeft: '10%', paddingRight: '10%' }}>
      <div data-aos="fade-up" data-aos-duration="3000">
        <h2 style={{ color: 'white' }}>Contact me</h2>
        <form id="contact-form" onSubmit={sendEmail}>
          <input name="name" type="text" class="feedback-input" placeholder="Name" />
          <input name="email" type="text" class="feedback-input" placeholder="Email" />
          <textarea name="message" class="feedback-input" placeholder="message"></textarea>
          <input type="submit" value="SUBMIT" />
        </form>
      </div>
    </div>


  );
};

export default Contact;